import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Security = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <h1 className="mb-4">Security & Protection</h1>
          <p className="lead">
            At Airclift Capital, security is our top priority. Learn about our
            comprehensive security measures designed to protect your assets.
          </p>

          <div className="mt-5">
            <h3>Security Features</h3>
            <ul className="mt-3">
              <li>
                <strong>Multi-Signature Wallets:</strong> Enhanced protection
                through multiple approval requirements
              </li>
              <li>
                <strong>Cold Storage:</strong> Majority of assets stored offline
                for maximum security
              </li>
              <li>
                <strong>Insurance Coverage:</strong> $250M coverage through
                Lloyd's of London
              </li>
              <li>
                <strong>Regulatory Compliance:</strong> Fully compliant with
                global financial regulations
              </li>
              <li>
                <strong>24/7 Monitoring:</strong> Continuous security monitoring
                and threat detection
              </li>
              <li>
                <strong>Segregated Accounts:</strong> Client assets kept
                separate from company assets
              </li>
            </ul>
          </div>

          <div className="mt-5">
            <h3>Certifications & Compliance</h3>
            <p>
              We maintain the highest security standards and comply with
              regulations across 60+ countries where we operate.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Security;
